import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoCondicaoPagamentoMultiselectComponent } from './novo-condicao-pagamento-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoCondicaoPagamentoMultiselectComponent],
  exports: [NovoCondicaoPagamentoMultiselectComponent]
})
export class NovoCondicaoPagamentoMultiselectModule {}
